export const strings = {
  microphoneAccess: {
    noPermission:
      'Unable to make calls. Your browser needs permission to use your microphone. Please reload the page after granting permission.',
    /**
     * @deprecated you no longer need to refresh the application to reconnect to the microphone
     */
    error:
      'We were unable to detect any audio devices. Please check your device and refresh the application.',
    errorSoft:
      'We cannot detect an audio device. Please check that your audio device is connected.',
    requestPermissionCta: 'Give Permission',
  },
  toasts: {
    setUserOfflineToast: 'You have been set to the `Offline` status',
    closingWhileInCall:
      'Warning: Closing or reloading Contact Center Pro will drop your current call.',
  },
  clearBrowserData: {
    failed:
      'Failed to clear browser data. Please try refreshing the page manually or contact support.',
    storageQuota:
      'Storage quota exceeded. Please clear some browser data manually and try again.',
    permission:
      'Permission denied when clearing browser data. Please check your browser settings.',
    indexedDB:
      'Failed to clear cached data. Please try closing other tabs or restarting your browser.',
  },
} as const;
